var React = require('react');

function PulseInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"pulse"),React.createElement("polyline",{"points":"48 320 112 320 176 64 240 448 304 224 336 320 400 320","style":{"fill":"none","stroke":"#E85A4F","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":1}),React.createElement("circle",{"cx":"432","cy":"320","r":"32","style":{"fill":"none","stroke":"#E85A4F","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":2})]);
}

PulseInline.defaultProps = {"width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = PulseInline;

PulseInline.default = PulseInline;
